<template>
    <div class="row">
        <div class="col-12 text-center">
            <div id="app" class="web-camera-container">
                <div class="camera-button">

                    <span class="fa-stack fa-lg " @click="toggleCamera">
                        <i class="fa fa-circle fa-stack-2x  text-warning"></i>
                        <i class="fa fa-camera fa-stack-1x fa-inverse"></i>
                    </span>
                </div>

                <div v-show="isCameraOpen && isLoading" class="camera-loading">
                    <ul class="loader-circle">
                        <li></li>
                        <li></li>
                        <li></li>
                    </ul>
                </div>

                <div v-if="isCameraOpen" v-show="!isLoading" class="camera-box" :class="{ 'flash' : isShotPhoto }">

                    <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div>

                    <video ref="camera" :width="450" :height="337.5" autoplay></video>


                </div>

                <canvas id="photoTaken" v-show="isPhotoTaken && !isLoading && isCameraOpen" ref="canvas" :width="460" :height="640"></canvas>
                <img id="imgGallery" v-if="isGalleryOpen" ref="imgGallery" :width="460" :height="640">


                <input type="file" @change="onFileChanged($event)"
                       id="file" name="file"
                       accept="image/png, image/jpeg">

                <div v-if="isCameraOpen && !isLoading" class="camera-shoot">
                    <span class="fa-stack fa-lg " @click="takePhoto">
                        <i class="fa fa-circle fa-stack-2x  text-success"></i>
                        <i class="fa fa-camera fa-stack-1x fa-inverse"></i>
                    </span>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "PictureNav",
        data() {
            return {
                isCameraOpen: false,
                isGalleryOpen: false,
                isPhotoTaken: false,
                isShotPhoto: false,
                isLoading: false,
                link: '#',
                srcImg:null
            };
        },
        methods:
            {

                toggleCamera() {
                    if (this.isCameraOpen) {
                        this.isCameraOpen = false;
                        this.isPhotoTaken = false;
                        this.isShotPhoto = false;
                        this.stopCameraStream();
                    } else {
                        this.isCameraOpen = true;
                        this.createCameraElement();
                    }
                },

                createCameraElement() {
                    this.isLoading = true;

                    const constraints = (window.constraints = {
                        audio: false,
                        video: {
                            facingMode: 'environment'
                        }
                    });


                    navigator.mediaDevices
                        .getUserMedia(constraints)
                        .then(stream => {
                            this.isLoading = false;
                            this.$refs.camera.srcObject = stream;
                        })
                        .catch(error => {
                            this.isLoading = false;
                            console.log(error)
                            alert("May the browser didn't support or there is some errors.");
                        });
                },

                stopCameraStream() {
                    let tracks = this.$refs.camera.srcObject.getTracks();

                    tracks.forEach(track => {
                        track.stop();
                    });
                },

                takePhoto() {
                    if (!this.isPhotoTaken) {
                        this.isShotPhoto = true;

                        const FLASH_TIMEOUT = 50;

                        setTimeout(() => {
                            this.isShotPhoto = false;
                        }, FLASH_TIMEOUT);
                    }

                    this.isPhotoTaken = !this.isPhotoTaken;

                    const context = this.$refs.canvas.getContext('2d', {'powerPreference': "high-performance"});
                    console.log(this.$refs.canvas)
                    console.log(context)
                    context.drawImage(this.$refs.camera, 0, 0);
                    console.log(context)
                    const canvas = document.getElementById("photoTaken").toDataURL("image/jpeg")
                    var blobCanvas = null
                    var self = this
                    document.getElementById("photoTaken").toBlob(function (blob) {
                        blobCanvas = blob

                        self.isPhotoTaken = !self.isPhotoTaken;
                        self.$emit('returnPictureNav', [blobCanvas, canvas])
                        console.log(blob);
                        console.log(blobCanvas);
                    }, 'image/png');


                },
                onFileChanged() {
                    this.isGalleryOpen = true
                    this.isPhotoTaken = true
                    this.isCameraOpen = true
                    this.isLoading = false
                    var self = this
                    var file = document.getElementById('file').files[0];
                    var reader  = new FileReader();
                    // it's onload event and you forgot (parameters)
                    reader.onload = function(e)  {
                        var image = document.getElementById("imgGallery");
                        // the result image data
                        console.log(e.target.result)
                        image.src = e.target.result;
                        //document.body.appendChild(image);
                        console.log(image)
                        const context = self.$refs.canvas.getContext('2d', {'powerPreference': "high-performance"});
                        image.addEventListener("load", (e2) => {
                            context.drawImage(image,0,0,self.$refs.canvas.width, self.$refs.canvas.height)
                            console.log(context)
                            console.log(e2)

                            const canvas = document.getElementById("photoTaken").toDataURL("image/jpeg")
                            var blobCanvas = null

                            document.getElementById("photoTaken").toBlob(function (blob) {
                                blobCanvas = blob

                                self.isPhotoTaken = !self.isPhotoTaken;
                                self.$emit('returnPictureNav', [blobCanvas, canvas])
                                console.log(blob);
                                console.log(blobCanvas);


                                self.isGalleryOpen = false
                                self.isPhotoTaken = false
                                self.isCameraOpen = false
                                self.isLoading = true
                            }, 'image/png');
                        })

                    }

                    // you have to declare the file loading
                    reader.readAsDataURL(file);


                },

            }
    }
</script>

<style scoped>

    .web-camera-container {
        padding: 2rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

    .camera-button {
        margin-bottom: 2rem;
    }

    .camera-box {

    .camera-shutter {
        opacity: 0;
        height: 337.5px;
        background-color: #fff;
        position: absolute;

    &
    .flash {
        opacity: 1;
    }

    }
    }

    .camera-shoot {
        margin: 1rem 0;

    button {
        height: 60px;
        width: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 100%;

    img {
        height: 35px;
        object-fit: cover;
    }

    }
    }

    .camera-loading {
        overflow: hidden;
        height: 100%;
        position: absolute;
        width: 100%;
        min-height: 150px;
        margin: 3rem 0 0 -1.2rem;

    ul {
        height: 100%;
        position: absolute;
        width: 100%;
        z-index: 999999;
        margin: 0;
    }

    .loader-circle {
        display: block;
        height: 14px;
        margin: 0 auto;
        top: 50%;
        left: 100%;
        transform: translateY(-50%);
        transform: translateX(-50%);
        position: absolute;
        width: 100%;
        padding: 0;

    li {
        display: block;
        float: left;
        width: 10px;
        height: 10px;
        line-height: 10px;
        padding: 0;
        position: relative;
        margin: 0 0 0 4px;
        background: #999;
        animation: preload 1s infinite;
        top: -50%;
        border-radius: 100%;

    &
    :nth-child(2) {
        animation-delay: .2s;
    }

    &
    :nth-child(3) {
        animation-delay: .4s;
    }

    }
    }
    }

    @keyframes preload {
        0% {
            opacity: 1
        }
        50% {
            opacity: .4
        }
        100% {
            opacity: 1
        }
    }

    }
</style>